
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import * as XLSX from 'xlsx';

const SundayMarketUploadTemplate: React.FC = () => {
  const downloadTemplate = () => {
    const templateData = [
      {
        'Timestamp': '2024-01-15',
        'Products List': 'Tomatoes',
        'Unit Price': 25.50,
        'Location': 'Sunday Market - Central',
        'Product Remarks': 'Fresh, Grade A'
      },
      {
        'Timestamp': '2024-01-15',
        'Products List': 'Onions',
        'Unit Price': 18.00,
        'Location': 'Sunday Market - North',
        'Product Remarks': 'Red onions, medium size'
      },
      {
        'Timestamp': '2024-01-15',
        'Products List': 'Potatoes',
        'Unit Price': 22.75,
        'Location': 'Sunday Market - South',
        'Product Remarks': ''
      }
    ];

    const worksheet = XLSX.utils.json_to_sheet(templateData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sunday Market Prices');

    // Set column widths
    const columnWidths = [
      { wch: 15 }, // Timestamp
      { wch: 20 }, // Products List
      { wch: 12 }, // Unit Price
      { wch: 25 }, // Location
      { wch: 20 }  // Product Remarks
    ];
    worksheet['!cols'] = columnWidths;

    XLSX.writeFile(workbook, 'sunday_market_prices_template.xlsx');
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Excel Upload Template</h3>
        <Button variant="outline" onClick={downloadTemplate} className="flex items-center gap-2">
          <Download className="h-4 w-4" />
          Download Template
        </Button>
      </div>

      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          <div className="space-y-2">
            <p className="font-medium">Required Excel columns:</p>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li><strong>Timestamp:</strong> Date of price collection (YYYY-MM-DD format)</li>
              <li><strong>Products List:</strong> Name of the product</li>
              <li><strong>Unit Price:</strong> Price per unit (numeric value)</li>
              <li><strong>Location:</strong> Sunday market location</li>
              <li><strong>Product Remarks:</strong> Additional notes (optional)</li>
            </ul>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default SundayMarketUploadTemplate;
